import React from 'react';
import { Button, Table, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useSwr from '@hooks/useSwr';
import CustomCard from '@components/CustomCard';

const ConsumptionPerEndpoint = () => {
  const { t } = useTranslation('attributes');
  const { data } = useSwr('/service-proxy/api-charging/endpoint-consumption');

  const columns = [
    {
      title: 'Endpoint',
      dataIndex: 'endpoint',
    },
    {
      title: t('consumption'),
      dataIndex: 'consumedAPI',
    },
  ];

  return (
    <CustomCard
      title={
        <>
          <span>{t('consumptionPerEndpoint')}</span>
          <Tooltip title={t('updatedAtCloseOfDay')}>
            <Button type="link" icon={<QuestionCircleOutlined />} />
          </Tooltip>
        </>
      }
      headStyle={{
        fontSize: '1.1rem',
        fontWeight: 'bold',
      }}
      bodyStyle={{
        padding: 16,
        height: '100%',
      }}
      style={{ width: '100%' }}
    >
      <Table
        columns={columns}
        dataSource={data}
        loading={!data}
        size="small"
        pagination={false}
        style={{ pointerEvents: 'none' }}
      />
    </CustomCard>
  );
};

export default ConsumptionPerEndpoint;
